'use strict';

import template from './cookies_line.html';

const saCookiesLine = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {},
      bindToController: true,
      controllerAs: 'ctrl',
      controller: [
        '$window',
        'config',
        'userModel',
        'modal',
        '$rootScope',
        '$scope',
        '$cookies',
        function ($window, config, userModel, modal, $rootScope, $scope, $cookies) {
          let self                  = this;
          this.userModel            = userModel;
          this.isCookiesLineEnabled = $rootScope.isCookiesLineEnabled !== undefined ? $rootScope.isCookiesLineEnabled : true;

          this.modalOpen = function () {
            modal.open({
              template: '<sa-cookies-line-modal done="close()"></sa-cookies-line-modal>'
            }).result.finally(function () {
              $state.go(toState.name, toParams);
            });
          }

          this.accept = function () {
            $rootScope.isCookiesLineEnabled = false;
          }

          $scope.$watch(function () {
            return $rootScope.facebookPixel;
          }, function (value) {
            if (!value) {
              $cookies.put('disable_fb_pixel', 'disabled');
            } else {
              $cookies.remove('disable_fb_pixel');
            }
          });

          $scope.$watch(function () {
            return $rootScope.analytics;
          }, function (value) {
            if (!value) {
              $cookies.put('disable_google_analytics', 'disabled');
            } else {
              $cookies.remove('disable_google_analytics');
            }
          });

          $scope.$watch(function () {
            return $rootScope.adWords;
          }, function (value) {
            if (!value) {
              $cookies.put('disable_google_adwords', 'disabled');
            } else {
              $cookies.remove('disable_google_adwords');
            }
          });

          $scope.$watch(function () {
            return $rootScope.taboola;
          }, function (value) {
            if (!value) {
              $cookies.put('disable_taboola', 'disabled');
            } else {
              $cookies.remove('disable_taboola');
            }
          });

          $scope.$watch(function () {
            return $rootScope.isCookiesLineEnabled;
          }, function (value) {
            if (!value) {
              $cookies.put('disable_cookies_line', 'disabled');
              self.isCookiesLineEnabled = false;
            } else {
              $cookies.remove('disable_cookies_line');
              self.isCookiesLineEnabled = true;
            }
          });
        }
      ]
    };
  }
];

export default saCookiesLine;



// WEBPACK FOOTER //
// ./app/src/directives/cookies_line.js